import { FormFactoryProvider } from '@meilleurtaux/form-factory'
import { formatPianoValue } from '@meilleurtaux/form-factory-ds'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App'
import { initDatadog } from 'utils/datadog'
import './index.css'

// Polyfill for Object.hasOwn (Node 16, Safari 14)
if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }
}

// form-factory-ds partage cette même instance dayjs (peer dependency) : sans ce
// réglage global, ses libellés de mois en mode d'affichage liste restent en anglais.
dayjs.locale('fr')

globalThis.formatPianoValue = formatPianoValue

initDatadog()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root container #root not found')
}

const root = ReactDOM.createRoot(rootElement)

document.addEventListener('mouseup', function (event) {
  const target = event.target as HTMLElement
  if (target && target.matches('.a[data-href]')) {
    const decodedString = atob(target.getAttribute('data-href') as string)
    if (target.getAttribute('target') === '_blank') window.open(decodedString)
    else globalThis.location.href = decodedString
  }
})

root.render(
  <React.StrictMode>
    <FormFactoryProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </FormFactoryProvider>
  </React.StrictMode>,
)
